import { Component, Injector, OnInit } from '@angular/core';
import { ComponentService } from '../../../shared/abstract/component.service';
import { RequestService } from '../../../shared/services/request.service';
import { GeneralQueryModel } from '../../../shared/model/general-query-model';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { ActionType } from '../../../shared/enum/actionType';
import { ManagementType } from '../../../shared/enum/managementType';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../../../shared/widgets/modal/modal.component';
import { debounceTime } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { FileParameter } from '../../../shared/interface/FileParameter';
interface SearchParams {
  searchTerm: string;
  columnName?: string;
}

@Component({
  selector: 'app-version-management',
  templateUrl: './app-version-management.component.html',
  styleUrl: './app-version-management.component.css',
})
export class AppVersionManagementComponent
  extends ComponentService<any>
  implements OnInit {
  dataSource = new MatTableDataSource<any>();
  currentCompany;
  appVersionSearchLength;
  url;

  pageIndex = 0;
  pageSize = 5;
  currentPage = 0;
  totalPages = 0;
  maxVisibleButtons = 5;
  Math = Math;

  propertiesForColumn: any[] = [];
  searchValuesForColumn: any[] = [];

  isSideNavOpen = false;
  selectedManagementType!: ManagementType;
  selectedActionType!: ActionType;

  ManagementType = ManagementType;
  ActionType = ActionType;

  inputValues: { [key: string]: string } = {};
  searchInput: string = '';
  private searchSubject: Subject<SearchParams> = new Subject();

  displayedColumns = ['releaseNote', 'versionName', 'applicationTypeId', 'releaseDate', 'applicationPath', 'options'];
  selectedAppVersion?: any;
  subDataSource = new MatTableDataSource<any>();
  filesToUpload: any = [];
  imageName = "";
  imageSize;
  fileControl = false;

  constructor(
    private _request: RequestService,
    injector: Injector,
    private _dialog: MatDialog
  ) {
    super(injector);

    // Debounce mekanizması
    this.searchSubject.pipe(debounceTime(600)).subscribe((searchParam) => {
      this.filter(searchParam.searchTerm, searchParam.columnName);
    });
  }

  ngOnInit(): void {
    if (
      this._appsService?.existCurrentProject?.companyId &&
      this._appsService?.existCurrentProject?.projectId
    ) {
      this.currentProject = this._appsService.existCurrentProject;
      this.currentCompany = this._appsService.existCurrentCompany;
      this.managementConfig();
    }

    this.cPSubs = this._appsService.currentProject.subscribe((project) => {
      this.currentProject = project;
      this.managementConfig();
    });
    this.url = environment.apiUrl + '/';
  }

  managementConfig() {
    this.getPaginatedQuery();
  }

  getPaginatedQuery() {
    let model: GeneralQueryModel = new GeneralQueryModel();
    model.companyId = this.currentCompany;
    model.propertyNames = this.propertiesForColumn;
    model.searchValues = this.searchValuesForColumn;
    model.and = true;
    model.orderColumn = '';
    model.order = 'desc';
    model.index = this.pageIndex;
    model.size = this.pageSize;

    this._request.getPaginatedAppVersion(model).then(_ => {
      if (_.items) {

        this.dataSource.data = _.items;
        this.appVersionSearchLength = _.count;
      }
    }).catch(err => {
      this.MessageBox(err.message ?? '', 'warn', 'center');
    }).finally(() => {
      this.updateTotalPages();
    });


  }

  onInputChange(event: Event, columnName?: string): void {
    const inputElement = event.target as HTMLInputElement;
    const searchTerm = inputElement.value;
    this.searchSubject.next({ searchTerm, columnName });
  }

  filter(searchTerm: string, columnName?: string): void {
    if (columnName) {
      var propertyIndex = this.propertiesForColumn.indexOf(columnName);
      if (propertyIndex != -1)
        if (searchTerm == '' || searchTerm == null || searchTerm == undefined) {
          this.propertiesForColumn.splice(propertyIndex, 1);
          this.searchValuesForColumn.splice(propertyIndex, 1);
        } else this.searchValuesForColumn[propertyIndex] = searchTerm;
      else {
        this.propertiesForColumn.push(columnName);
        var newPropertyIndex = this.propertiesForColumn.indexOf(columnName);
        this.searchValuesForColumn[newPropertyIndex] = searchTerm;
      }
    }

    this.currentPage = 0;
    this.pageIndex = 0;

    this.getPaginatedQuery();
  }

  get visiblePageNumbers(): number[] {
    const start = Math.max(
      0,
      Math.min(
        this.currentPage - Math.floor(this.maxVisibleButtons / 2),
        this.totalPages - this.maxVisibleButtons
      )
    );
    return Array.from(
      { length: Math.min(this.maxVisibleButtons, this.totalPages) },
      (_, i) => start + i + 1
    );
  }

  onPageChange(pageIndex: number) {
    if (pageIndex >= 0 && pageIndex < this.totalPages) {
      this.currentPage = pageIndex;
    }
    this.pageIndex = pageIndex;
    this.getPaginatedQuery();
  }

  updatePageSize(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    this.pageSize = parseInt(selectElement.value, 10);
    this.updateTotalPages();
    this.currentPage = 0;
    this.pageIndex = 0;
    this.getPaginatedQuery();
  }

  updateTotalPages() {
    this.totalPages = Math.ceil(this.appVersionSearchLength / this.pageSize);
  }

  deleteAppVersion(element) {
    const dialogRef = this._dialog.open(ModalComponent, {
      width: '400px',
      data: {
        type: 'confirm',
        title: 'deleteAppVersion',
        body: 'deleteAppVersionConfirm',
        ok: 'confirm',
        cancel: 'cancel',
        color: 'warn',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this._request
          .deleteAppVersion(parseInt(element.id))
          .then((res) => {
            if (res.code == 1) {
              this.dataSource.data = this.dataSource.data.filter(
                (u) => u.id != element.id
              );
              this.MessageBox(res.message ?? '', 'primary', 'center');
            } else if (res.code == 2) {
              this.MessageBox(res.message ?? '', 'orange', 'center');
            } else {
              this.MessageBox(res.message ?? '', 'warn', 'center');
            }
          })
          .catch((err) => {
            this.MessageBox(
              this.languageKey('requiredField'),
              'warn',
              'center'
            );
          });
      }
      this._appsService.logInfo("Uygulama versiyonu silindi");
    });
  }

  uploadFile(files, element) {
    if (files.length === 0) {
      return;
    }

    for (var i = 0; i < files.length; i++) {
      this.imageName = files[i].name;
      this.imageSize = files[i].size;
      if (this.imageSize < 209715200 && files[i] != undefined) {
        this.filesToUpload.push(files[i]);
      }
      else {
        this.MessageBox(this.languageKey("needToChooseSmallFile"), 'orange', 'right');
        break;
      }
    }
    this.appVersionAction(element)
  }

  appVersionAction(element) {
    let fileParameters: FileParameter[] = [];
    this.filesToUpload.forEach((item) => {
      let fileParameter: FileParameter = { data: item, fileName: item.name };
      fileParameters.push(fileParameter);
    });
    this._request.uploadAppVersionFiles(fileParameters, Number(element.id)).then(res => { 
      if (res.code === 1) this.MessageBox(res.message ?? '', 'primary', 'center');
      else if (res.code === 2) this.MessageBox(res.message ?? '', 'orange', 'center');
      else this.MessageBox(res.message ?? '', 'warn', 'center');
    });
    this._appsService.logInfo("Ipa veya apk yüklendi");
  }

  //appVersionAction(element) {
  //  const fileParameters: FileParameter[] = this.filesToUpload.map(item => ({
  //    data: item,
  //    fileName: item.name
  //  }));

  //  // element.id is a string, so coerce to number
  //  this._request.uploadAppVersionFiles(fileParameters, Number(element.id)).then(res => {
  //      if (res.code === 1) this.MessageBox(res.message ?? '', 'primary', 'center');
  //      else if (res.code === 2) this.MessageBox(res.message ?? '', 'orange', 'center');
  //      else this.MessageBox(res.message ?? '', 'warn', 'center');
  //    });
  //}

  openSideNav(
    managementType: ManagementType,
    actionType: ActionType,
    company?: any
  ) {
    this.selectedManagementType = managementType;
    this.selectedActionType = actionType;
    this.isSideNavOpen = true;
    this.selectedAppVersion = company ? { ...company } : null;
    this._appsService.logInfo("Versiyon " + this.languageKey(actionType) + " açıldı");
  }
}
